import CONSTANTS from '../constants'
import { isLoggedIn } from '../../utils/helper'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	isFetching: false,
	isUserLogin: isLoggedIn(),
	isAuthenticated: false,
	hasError: false,
	data: EMPTY_OBJECT,
	faclityData: EMPTY_OBJECT,
	email: null,
	role: null,
	errorMessage: '',
	id: null,
	orgId: ''
}

const VehilceReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {

		//LOGIN HANDLING
		case CONSTANTS.GET_VEHILCE_LIST_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.GET_VEHILCE_LIST_SUCCESS:
			return { ...state, loader: false, data: action.data, isAuthenticated: true, hasError: false, errorMessage: '' }
		case CONSTANTS.GET_VEHILCE_LIST_FAILURE:
			return { ...state, loader: false, errorMessage: 'There is some Error' }

		case CONSTANTS.ADD_VEHILCE_REQUEST:
			return { ...state, isFetching: true, errorMessage: '' }
		case CONSTANTS.ADD_VEHILCE_SUCCESS:
			return { ...state, isFetching: false, data: action.data, isAuthenticated: true, hasError: false, errorMessage: '' }
		case CONSTANTS.ADD_VEHILCE_FAILURE:
			return { ...state, isFetching: false, errorMessage: 'There is some Error' }

		case CONSTANTS.EDIT_VEHILCE_REQUEST:
			return { ...state, isFetching: true, errorMessage: '' }
		case CONSTANTS.EDIT_VEHILCE_SUCCESS:
			return { ...state, isFetching: false, data: action.data, isAuthenticated: true, hasError: false, errorMessage: '' }
		case CONSTANTS.EDIT_VEHILCE_FAILURE:
			return { ...state, isFetching: false, errorMessage: 'There is some Error' }
			
		default:
			return state
	}
}

export default VehilceReducer